<script setup lang="ts">
import { computed } from "vue";

import { STATUS_KIND_ICON_MAP } from "~/common/filter";
import { DEFAULT_CHIP_COLOR } from "~/constants/style";
import { StatusKind } from "~/shared/enums";
import { UnstartedIcon } from "~/status-icons";
import { useDataStore, usePageStore } from "~/stores";
import { getChipColorsHex } from "~/utils/color";

const props = defineProps<{
  duid: string;
  colorHex?: string;
  isContrast?: boolean;
}>();

const dataStore = useDataStore();
const pageStore = usePageStore();

const statusIconObject = computed(() => {
  const status = dataStore.getStatusByDuid(props.duid);
  const icon = status ? (STATUS_KIND_ICON_MAP.get(status.kind) ?? UnstartedIcon) : UnstartedIcon;
  const color =
    props.colorHex ??
    (status
      ? props.isContrast
        ? getChipColorsHex(status.colorHex, pageStore.theme).fore
        : status.colorHex
      : DEFAULT_CHIP_COLOR);
  const args: Record<string, unknown> = {};
  if (status && status.kind === StatusKind.STARTED) {
    const property = dataStore.getPropertyByDuid(status.propertyDuid);
    if (property) {
      const startedStatuses = dataStore.getStatusesByKinds([StatusKind.STARTED], property);
      const statusIndex = startedStatuses.findIndex((s) => s.duid === props.duid) + 1;
      args.progress = statusIndex / (startedStatuses.length + 1);
    }
  }
  return { icon, color, args };
});
</script>

<template>
  <component :is="statusIconObject.icon" :style="{ color: statusIconObject.color }" v-bind="statusIconObject.args" />
</template>
